import { ethers } from 'ethers';
import axiosToken from '../../social-wallet/AxiosToken';
import type { HorusSigner } from './types';

interface CustodialSignerConfig {
  evmAddress: string;
  walletId: string;
  walletIndex: number;
  password?: string;
}

export function createCustodialSigner(config: CustodialSignerConfig): HorusSigner {
  const { evmAddress, walletId, walletIndex, password } = config;
  const normalizedAddress = evmAddress.toLowerCase();

  return {
    type: 'EOA',
    getIdentifier: () => ({
      identifier: normalizedAddress,
      identifierKind: "Ethereum" as const,
    }),
    signMessage: async (message: string): Promise<Uint8Array> => {
      const response = await axiosToken.post('/signMessage', {
        walletId,
        walletIndex,
        network: 'ETHEREUM',
        message,
        ...(password ? { password } : {}),
      });

      const signature = response.data.body
        ? JSON.parse(response.data.body).signature
        : response.data.signature;

      if (!signature) {
        throw new Error('Failed to get signature from backend');
      }

      return ethers.utils.arrayify(signature);
    },
  };
}
